import RestBuilder from '../rest/RestBuilder';

const rest = new RestBuilder().mimeJson().successCodes([200]).build();

const PasswordService = {
  forgotPassword: email => rest({
    method: 'POST',
    path: '/api/customer-self-management/rest/customerSelfManagement/identity/forgotpassword',
    entity: {
      email
    }
  }),

  resetPassword: (password, token) => rest({
    method: 'POST',
    path: '/api/customer-self-management/rest/customerSelfManagement/identity/me/resetpassword',
    entity: {
      password,
      token
    }
  }),

  verifyToken: token => rest({
    method: 'GET',
    path: `api/customer-self-management/rest/customerSelfManagement/identity/verify?resetCode=${token}`
  })
};

export default PasswordService;



/** WEBPACK FOOTER **
 ** ./src/services/PasswordService.js
 **/